<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import WorkflowInput from "@/components/design/workflow/WorkflowInput.vue";
import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import Workflow, {defaultWorkflow} from "@/types/Workflow";
import {workflowCreate} from "@/utils/heading";

@Component({components: {'ontos-workflow-input': WorkflowInput}})
class CreateClass extends WorkspaceRouteComponent {
  get heading() {
    return workflowCreate(this.workspace)
  }

  //A mesma semente do modal de criar: ela mora no types/Workflow
  workflow: Workflow = defaultWorkflow()
  declare $refs: {input: InstanceType<typeof WorkflowInput>}

  async save() {
    try {
      if (this.$refs.input.validateModel()) {
        await this.createWorkflow(this.workflow)
        this.info(this.$tt('info.workflow-created', {name: this.workflow.name}))
        await this.$router.push({name: 'view-workflow', params: {...this.$route.params, workflow: this.workflow.alias}})
      }
    } catch (err) {
      this.throwError(this.$tt('error.create-workflow', {name: this.workflow.name}), err)
    }
  }
}


export default toNative(CreateClass)
</script>
<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form>
      <ontos-page-header v-bind="heading"/>
      <v-row>
        <v-col cols="12">
          <ontos-workflow-input ref="input" :value="workflow" @input="workflow = $event" :workflows="workspace.workflows"
                                start-with-auto-alias/>
        </v-col>
        <!-- Salvar à direita, como na edição e nos modais -->
        <v-col cols="12" class="text-right">
          <v-btn size="small" color="primary" @click="save()">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>
